import { Box, Typography } from "@mui/material";

export default function Workspaces() {
	return (
		<Box>
			<Typography variant="h4" fontWeight={700}>
				Workspaces
			</Typography>
			<Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
				Manage your test workspaces (Coming soon)
			</Typography>
		</Box>
	);
}
